module.exports = __webpack_public_path__ + "img/37.1792331c.png";